(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vnm-marketplace-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVnmMarketplace = (root) => {
      if (!root || root.dataset.vnmMarketplaceReady === 'true') return;
      root.dataset.vnmMarketplaceReady = 'true';

      root.querySelectorAll('[data-campaign-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('[data-campaign-track]');
        const cards = Array.from(carousel.querySelectorAll('[data-campaign-card]'));
        const dots = Array.from(carousel.querySelectorAll('[data-campaign-dot]'));
        const previousButton = carousel.querySelector('[data-campaign-previous]');
        const nextButton = carousel.querySelector('[data-campaign-next]');
        if (!track || cards.length < 2) return;

        let frame;
        const updateDots = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const hasOverflow = track.scrollWidth > track.clientWidth + 2;
            const isAtStart = track.scrollLeft <= 2;
            const isAtEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
            carousel.classList.toggle('has-overflow', hasOverflow);
            carousel.classList.toggle('is-at-start', isAtStart);
            carousel.classList.toggle('is-at-end', isAtEnd);
            if (previousButton && (isAtStart || !hasOverflow) && document.activeElement === previousButton) {
              if (nextButton && hasOverflow && !isAtEnd) nextButton.focus({ preventScroll: true });
              else track.focus({ preventScroll: true });
            }
            if (nextButton && (isAtEnd || !hasOverflow) && document.activeElement === nextButton) {
              if (previousButton && hasOverflow && !isAtStart) previousButton.focus({ preventScroll: true });
              else track.focus({ preventScroll: true });
            }
            if (previousButton) {
              previousButton.disabled = isAtStart || !hasOverflow;
              previousButton.setAttribute('aria-disabled', isAtStart || !hasOverflow ? 'true' : 'false');
            }
            if (nextButton) {
              nextButton.disabled = isAtEnd || !hasOverflow;
              nextButton.setAttribute('aria-disabled', isAtEnd || !hasOverflow ? 'true' : 'false');
            }
            const trackCenter = track.scrollLeft + track.clientWidth / 2;
            let activeIndex = 0;
            let nearestDistance = Infinity;

            cards.forEach((card, index) => {
              const cardCenter = card.offsetLeft + card.offsetWidth / 2;
              const distance = Math.abs(trackCenter - cardCenter);
              if (distance < nearestDistance) {
                nearestDistance = distance;
                activeIndex = index;
              }
            });

            dots.forEach((dot, index) => {
              const isActive = index === activeIndex;
              dot.classList.toggle('is-active', isActive);
              dot.setAttribute('aria-current', isActive ? 'true' : 'false');
            });
          });
        };

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            const card = cards[index];
            if (!card) return;
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
          });
        });

        if (previousButton) {
          previousButton.addEventListener('click', () => {
            const firstVisibleIndex = cards.findIndex((card) => card.offsetLeft + card.offsetWidth > track.scrollLeft + 2);
            const cardGap = parseFloat(window.getComputedStyle(track).gap) || 0;
            const pageSize = Math.max(1, Math.floor(track.clientWidth / (cards[0].offsetWidth + cardGap)));
            const targetIndex = Math.max(0, firstVisibleIndex - pageSize);
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            track.scrollTo({ left: Math.max(0, cards[targetIndex].offsetLeft - cards[0].offsetLeft), behavior: reducedMotion ? 'auto' : 'smooth' });
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', () => {
            const trackRight = track.scrollLeft + track.clientWidth;
            const nextCard = cards.find((card) => card.offsetLeft + card.offsetWidth > trackRight + 2);
            if (!nextCard) return;
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            track.scrollTo({ left: nextCard.offsetLeft - cards[0].offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
          });
        }

        track.addEventListener('scroll', updateDots, { passive: true });
        window.addEventListener('resize', updateDots, { passive: true });
        updateDots();
      });

      root.querySelectorAll('[data-collection-carousel]').forEach((carousel) => {
        const track = carousel.querySelector('[data-collection-track]');
        const panels = Array.from(carousel.querySelectorAll('[data-collection-panel]'));
        const previousButton = carousel.querySelector('[data-collection-previous]');
        const nextButton = carousel.querySelector('[data-collection-next]');
        if (!track || panels.length < 2) return;

        let frame;
        const updateState = () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            const hasOverflow = track.scrollWidth > track.clientWidth + 2;
            const isAtStart = track.scrollLeft <= 2;
            const isAtEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
            carousel.classList.toggle('has-overflow', hasOverflow);
            carousel.classList.toggle('is-at-start', isAtStart);
            carousel.classList.toggle('is-at-end', isAtEnd);

            if (previousButton && (isAtStart || !hasOverflow) && document.activeElement === previousButton) {
              if (nextButton && hasOverflow && !isAtEnd) nextButton.focus({ preventScroll: true });
              else track.focus({ preventScroll: true });
            }
            if (nextButton && (isAtEnd || !hasOverflow) && document.activeElement === nextButton) {
              if (previousButton && hasOverflow && !isAtStart) previousButton.focus({ preventScroll: true });
              else track.focus({ preventScroll: true });
            }
            if (previousButton) {
              previousButton.disabled = isAtStart || !hasOverflow;
              previousButton.setAttribute('aria-disabled', isAtStart || !hasOverflow ? 'true' : 'false');
            }
            if (nextButton) {
              nextButton.disabled = isAtEnd || !hasOverflow;
              nextButton.setAttribute('aria-disabled', isAtEnd || !hasOverflow ? 'true' : 'false');
            }
          });
        };

        const scrollToPanel = (direction) => {
          const firstOffset = panels[0].offsetLeft;
          let currentIndex = 0;
          let nearestDistance = Infinity;

          panels.forEach((panel, index) => {
            const panelLeft = panel.offsetLeft - firstOffset;
            const distance = Math.abs(track.scrollLeft - panelLeft);
            if (distance < nearestDistance) {
              nearestDistance = distance;
              currentIndex = index;
            }
          });

          const targetIndex = Math.max(0, Math.min(panels.length - 1, currentIndex + direction));
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollTo({
            left: panels[targetIndex].offsetLeft - firstOffset,
            behavior: reducedMotion ? 'auto' : 'smooth'
          });
        };

        if (previousButton) previousButton.addEventListener('click', () => scrollToPanel(-1));
        if (nextButton) nextButton.addEventListener('click', () => scrollToPanel(1));
        track.addEventListener('scroll', updateState, { passive: true });
        window.addEventListener('resize', updateState, { passive: true });
        updateState();
      });

      root.querySelectorAll('[data-video-section]').forEach((videoSection) => {
        const clearMoastHeading = () => {
          const carousel = videoSection.querySelector('moast-carousel');
          if (!carousel) return false;
          carousel.setAttribute('header-text', '');
          return true;
        };

        if (clearMoastHeading()) return;

        const observer = new MutationObserver(() => {
          if (clearMoastHeading()) observer.disconnect();
        });
        observer.observe(videoSection, { childList: true, subtree: true });
        window.setTimeout(() => observer.disconnect(), 10000);
      });
    };

    document.querySelectorAll('[data-vnm-marketplace]').forEach(initializeVnmMarketplace);
    document.addEventListener('shopify:section:load', (event) => {
      initializeVnmMarketplace(event.target.querySelector('[data-vnm-marketplace]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
